/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {supportPhoneStatus} from '../api'

export const useMutationSupportPhoneStatus = createReactQueryMutationHook('supportPhoneStatus', supportPhoneStatus)
